import { render, staticRenderFns } from "./OfferDetail.vue?vue&type=template&id=15955dce"
import script from "./OfferDetail.vue?vue&type=script&lang=js"
export * from "./OfferDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports